import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { of } from 'rxjs';

import { AuthService } from './auth-service';

@Injectable({ providedIn: 'root' })
export class AuthMockService implements AuthService {
  constructor(private router: Router) {}

  userData$ = of({
    id: 'Z000NWDH',
    title: 'Test User',
    email: 'test.user@siemens.com',
    company: 'IT APS DEV'
  });

  getToken() {
    return 'Test1234$';
  }

  login() {
    this.router.navigate(['/main']);
    return of(undefined);
  }

  logout() {
    this.router.navigate(['/']);
  }

  softLogout() {
    this.router.navigate(['/']);
  }
}
